import { useMemo } from 'react';
import { useAppSelector } from './redux';
import { useLicenseCheck } from './useLicenseCheck';

export type ShipmentTrackerPermissions = {
  canRead: boolean;
  canWrite: boolean;
  canViewFinancials: boolean;
};

export function useShipmentTrackerPermissions(): ShipmentTrackerPermissions {
  const permissions = useAppSelector(
    (state) => state.profile.contact?.permissions ?? []
  );
  // null = owner account, string = subuser, undefined = contact not yet loaded
  const parentUserId = useAppSelector(
    (state) => state.profile.contact?.parentUserId
  );
  // Owner users have no user_permission rows - backend bypasses permission check for them.
  // We mirror that: owner access is determined by active subscription, not stored permissions.
  const hasLicense = useLicenseCheck('shipment_tracker');

  return useMemo(() => {
    const isOwner = parentUserId === null;
    if (isOwner) {
      return {
        canRead: hasLicense,
        canWrite: hasLicense,
        canViewFinancials: hasLicense,
      };
    }
    return {
      canRead: permissions.includes('shipment_tracker_read'),
      canWrite: permissions.includes('shipment_tracker_write'),
      canViewFinancials: permissions.includes('shipment_tracker_financials_read'),
    };
  }, [permissions, parentUserId, hasLicense]);
}
